/*
 * (c) Copyright 2024 Calabrio, Inc.
 * All Rights Reserved. www.calabrio.com LICENSED MATERIALS
 * Property of Calabrio, Inc., Minnesota, USA
 *
 * No part of this publication may be reproduced, stored or transmitted,
 * in any form or by any means (electronic, mechanical, photocopying,
 * recording or otherwise) without prior written permission from Calabrio, Inc.
 */

import Vue from 'vue';
import axios from 'axios'

export default {
  API: {
    PERFORMANCE_FETCH_FILTERS: '/chatAnalytics/chatFilters',
    PERFORMANCE_BUILD_INTENT_TO_CONTAIN_CONVERSATION_CHART: '/vaPerformance/containedConversations',
    PERFORMANCE_BUILD_INTENT_TO_HANDOFF_CONVERSATION_CHART: '/vaPerformance/handedOffConversations',
    PERFORMANCE_BUILD_INTENT_TO_CONVERSATIONS_BY_LANGUAGES_CHART: '/vaPerformance/conversationsByLanguages',
    PERFORMANCE_BUILD_INTENT_TO_CONVERSATIONS_BY_CHANNELS_CHART: '/vaPerformance/conversationsByChannels',
    PERFORMANCE_BUILD_INTENT_TO_MESSAGE_UNDERSTANDING_CHART: '/vaPerformance/messageUnderstanding',
    PERFORMANCE_BUILD_INTENT_TO_INTENTS: '/vaPerformance/intents'
  },
  
  cachedHash: {},
  cancelTokens: [],

  getRequest(authUser, url, headers) {
    if(authUser.accessToken) {
      if(headers == null) headers = {};
      headers["Authorization"] = "Bearer " + authUser.accessToken;
      headers["Api-Configs"] = JSON.stringify(authUser.config.api.configs);
      if(authUser.sessionId) {
        headers['Auth-Host'] = authUser.authHost || "";
        headers['Auth-Session-Id'] = authUser.sessionId;
        headers['Auth-Product-Name'] = authUser.productName || "";
        headers['Auth-Options'] = authUser.authOptions || "";
      }

      return axios.get(url, {headers: headers, timeout: 300000});
    }
    else {
      return null;
    }
  },

  postRequest(authUser, url, payload, headers) {
    if(authUser.accessToken) {
      if(headers == null) headers = {};
      headers["Authorization"] = "Bearer " + authUser.accessToken;
      headers["Api-Configs"] = JSON.stringify(authUser.config.api.configs);
      if(authUser.sessionId) {
        headers['Auth-Host'] = authUser.authHost || "";
        headers['Auth-Session-Id'] = authUser.sessionId;
        headers['Auth-Product-Name'] = authUser.productName || "";
        headers['Auth-Options'] = authUser.authOptions || "";
      }

      let cancelTokenKey = url;
      if(this.cancelTokens[cancelTokenKey]) {
        // cancel request
        this.cancelTokens[cancelTokenKey].cancel();
      }
      this.cancelTokens[cancelTokenKey] = axios.CancelToken.source();

      let options = {
        timeout: 300000, // timeout in 5 mins
        headers: headers,
        cancelToken: this.cancelTokens[cancelTokenKey].token
      }

      return axios.post(url, payload, options);
    }
    else {
      return null;
    }
  },

  fetchFilters(authUser) {
    let url = Vue.WyConstants.SERVER.PERFORMANCE_HOST + this.API.PERFORMANCE_FETCH_FILTERS;
    return this.getRequest(authUser, url);
  },

  fetchIntentToContainConversationChartData(authUser, payload) {
    let url = Vue.WyConstants.SERVER.PERFORMANCE_HOST + this.API.PERFORMANCE_BUILD_INTENT_TO_CONTAIN_CONVERSATION_CHART;
    return this.postRequest(authUser, url, payload);
  },

  fetchIntentToHandedOffConversationChartData(authUser, payload) {
    let url = Vue.WyConstants.SERVER.PERFORMANCE_HOST + this.API.PERFORMANCE_BUILD_INTENT_TO_HANDOFF_CONVERSATION_CHART;
    return this.postRequest(authUser, url, payload);
  },

  fetchIntentToConversationByLanguagesChartData(authUser, payload) {
    let url = Vue.WyConstants.SERVER.PERFORMANCE_HOST + this.API.PERFORMANCE_BUILD_INTENT_TO_CONVERSATIONS_BY_LANGUAGES_CHART;
    return this.postRequest(authUser, url, payload);
  },

  fetchIntentToConversationByChannelsChartData(authUser, payload) {
    let url = Vue.WyConstants.SERVER.PERFORMANCE_HOST + this.API.PERFORMANCE_BUILD_INTENT_TO_CONVERSATIONS_BY_CHANNELS_CHART;
    return this.postRequest(authUser, url, payload);
  },

  fetchIntentToMessageUnderstandingChartData(authUser, payload) {
    let url = Vue.WyConstants.SERVER.PERFORMANCE_HOST + this.API.PERFORMANCE_BUILD_INTENT_TO_MESSAGE_UNDERSTANDING_CHART;
    return this.postRequest(authUser, url, payload);
  },

  fetchIntentToIntents(authUser, payload) {
    let url = Vue.WyConstants.SERVER.PERFORMANCE_HOST + this.API.PERFORMANCE_BUILD_INTENT_TO_INTENTS;
    return this.postRequest(authUser, url, payload);
  },
}